import API from '../../api';

export default ({ orderRef, entityRef, coordinates }) => {
  const body = {
    coordinates,
  };
  return API.updateDestination({ entityRef, orderRef, body });
};
